<h1 mat-dialog-title>Historico Cliente</h1>
<div mat-dialog-content class="full-width">  
    <div class="row">
        <div class="col-2">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Id</mat-label>
                <input [(ngModel)]="data.id" matInput readonly>
            </mat-form-field>
        </div>
        <div class="col-10">
            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                <mat-label>Cliente</mat-label>
                <input [(ngModel)]="data.clientName" matInput readonly>
            </mat-form-field>
        </div> 
    </div>

    <div class="full-width">
        <section class="tabel-container mat-elevation-z8" tabindex="0">
            <table mat-table [dataSource]="sales" class="full-width">
                <!-- Coluna quantidade -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> Id </th>
                    <td mat-cell *matCellDef="let sale"> {{ sale.id }} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Coluna Nome -->
                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef> Data Pedido </th>
                    <td mat-cell *matCellDef="let sale"> {{ sale.createdAt | date : 'dd/MM/yyyy HH:MM'}} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="payment">
                    <th mat-header-cell *matHeaderCellDef> Forma Pagamento </th>
                    <td mat-cell *matCellDef="let sale"> {{ sale.payment }} | {{ sale.paymentTwo }} </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="products">
                    <th mat-header-cell *matHeaderCellDef> Produtos </th>
                    <td mat-cell *matCellDef="let sale"> 
                        <ng-container *ngFor="let productSold of sale.productSolds">
                            {{ productSold.quantity }} - {{ productSold.product.name }} |
                        </ng-container>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <!-- Coluna preco -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Valor Pedido</th>
                    <td mat-cell *matCellDef="let sale"> {{ sale.amount | currency:'BRL'}}
                    </td>
                </ng-container>
                
                <!-- Coluna preco total -->
                <!-- definir como vai ser as linhas e a ordem das colunas -->
                <tr mat-header-row *matHeaderRowDef="ordemColunasTabela; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
            </table>
        </section>       
    </div>
    
</div>
